import React, { useState, useRef, useEffect } from "react";
import {
    TextField,
    Grid,
    Box,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    TextareaAutosize,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import AccountMasterCashBank from "../../../Helper/AccountMasterHelp";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../..";
import "./AwakAdvance.css"
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";
import Swal from "sweetalert2";
import AwakEntryhelp from "../../../Helper/PattiAwakEntryHelp";
import { OutwordPostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck";
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange";

// Common style for all table headers

//Global Variables
var partyName = "";
var partyCode = "";
var accoid = "";
var newId = "";
var brokerName = "";
var brokerCode = "";
var narration = "";

const headerCellStyle = {
    fontWeight: "bold",
    backgroundColor: "#3f51b5",
    color: "white",
    padding: "6px",
    textAlign: "center",
    "&:hover": {
        backgroundColor: "#303f9f",
        cursor: "pointer",
    },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const AwakAdvance = () => {
    const companyCode = sessionStorage.getItem("Company_Code");
    const Year_Code = sessionStorage.getItem("Year_Code");
    const username = sessionStorage.getItem("username");
    const TCSApplicable = sessionStorage.getItem("TCSApplicable");
    const User_Id = sessionStorage.getItem("User_ID");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigatedRecord = searchParams.get("navigatedRecord");
    const permissions = location.state?.permissionsData;

    //State Management
    const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
    const [recordLabels, setRecordLabels] = useState({});
    const [users, setUsers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMode, setPopupMode] = useState("add");
    const [selectedUser, setSelectedUser] = useState({});
    const [deleteMode, setDeleteMode] = useState(false);
    const [itemCode, setItemCode] = useState("");
    const [item_Name, setItemName] = useState("");
    const [godowncode, setgodowncode] = useState("");
    const [godown_name, setgodown_name] = useState("");
    const [brand_code, setBrandCode] = useState("");
    const [brand_name, setBrandName] = useState("");
    const [itemCodeAccoid, setItemCodeAccoid] = useState("");


    //Head Section State Managements
    const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
    const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
    const [editButtonEnabled, setEditButtonEnabled] = useState(false);
    const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
    const [backButtonEnabled, setBackButtonEnabled] = useState(true);
    const [isEditMode, setIsEditMode] = useState(false);
    const [highlightedButton, setHighlightedButton] = useState(null);
    const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [lastTenderDetails, setLastTenderDetails] = useState([]);
    const [lastTenderData, setLastTenderData] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [isChecked, setIsChecked] = useState(false);
    const [gstNo, setGstNo] = useState("");
    const [isHandleChange, setIsHandleChange] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenEInvoice, setIsOpenEInvoice] = useState(false);
    const [isOpenEwayBill, setIsOpenEwayBill] = useState(false);


    const [billToManuallySet, setBillToManuallySet] = useState(false);
    const [shipToManuallySet, setShipToManuallySet] = useState(false);
    const [bill_To_Name, setBillToName] = useState("");
    const [ship_To_Name, setShipToName] = useState("");
    const [Awakcode, setAwakCode] = useState("");
    const [AwakId, setAwakId] = useState("");
    const [awakChanged, setAwakChanged] = useState(false);
    const [amountInWords, setAmountInWords] = useState('');


    const selectedRecord = location.state?.selectedRecord;
    const navigate = useNavigate();
    const inputRef = useRef(null);

    console.log(selectedRecord)

    //SET Focus to the ADD Buttons.
    const addButtonRef = useRef(null);
    const firstInputRef = useRef(null);
    const setFocusToFirstField = () => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    };

    //Initial Formdata

    const initialFormData = {
        Doc_No: "",
        Doc_Date: new Date().toISOString().split("T")[0],
        Cash_Bank_Ac: "",
        Company_Code: companyCode,
        Year_Code: Year_Code,
        Ac_Code: "",
        Narration: "",
        cb: 0,
        Advance_Type: 'A',
        Advance: 0.00,
        Created_By: "",
        Modified_By: "",
        Awak_No: 0,
        Awak_Id: 0,
        chequeno: "",
    };

    //ALL Help Section State managements
    const [formData, setFormData] = useState(initialFormData);
    const [partyMobNo, setPartyMobNo] = useState("");
    const [broker, setBroker] = useState("");
    const [framer, setFramer] = useState("");
    const [frameraccoid, setFramerAccoid] = useState("");

    //Validation Input feilds
    const validateNumericInput = (e) => {
        e.target.value = e.target.value.replace(/[^0-9.-]/g, "");
    };

    //Handle Records OnChange Method
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => {
            const updatedFormData = { ...prevState, [name]: value };
            return updatedFormData;
        });

        setAwakChanged(false);
    };

    useEffect(() => {
        if (isHandleChange) {
            handleCancel();
            setIsHandleChange(false);
        }
    }, []);

    //fetchLast Records to get the next doc no
    const fetchLastRecord = () => {
        fetch(
            `${API_URL}/get-next-doc-no-AwakAdvance?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Failed to fetch last record");
                }
                return response.json();
            })
            .then((data) => {
                const newDocNo = data.next_doc_no;
                setFormData((prevState) => ({
                    ...prevState,
                    Doc_No: newDocNo,
                }));
            })
            .catch((error) => {
                console.error("Error fetching last record:", error);
            });
    };

    //handle record Add.
    const handleAddOne = async () => {
        setAddOneButtonEnabled(false);
        setSaveButtonEnabled(true);
        setCancelButtonEnabled(true);
        setEditButtonEnabled(false);
        setDeleteButtonEnabled(false);
        setIsEditing(true);
        fetchLastRecord();
        setFormData(initialFormData);
        partyName = "";
        partyCode = "";
        brokerName = "";
        brokerCode = "";


        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    //handle Edit record functionality.
    const handleEdit = async () => {

        const Post_Date = sessionStorage.getItem("Post_Date");
        const Outword_Date = sessionStorage.getItem("Outword_Date")
        if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
            return;
        }

        const accountingYearData = sessionStorage.getItem("Accounting_Year");
        const formattedEntryDate = formData.Doc_Date;
        const isValid = validateDocumentDate(
            formattedEntryDate,
            accountingYearData
        );

        if (!isValid) {
            return;
        }

        const isUsed = await checkAdvanceUsage(formData.Doc_No);

        if (isUsed) {
            Swal.fire({
                icon: "error",
                title: "Cannot Edit",
                text: "This Doc No is already used in Patti. You cannot Edit it.",
                confirmButtonColor: "#d33",
            });
            return;
        }

        if (!formData?.Doc_No) {
            console.error(
                "❌ Cannot edit: formData.Id is missing or invalid",
                formData
            );
            Swal.fire({
                icon: "error",
                title: "Invalid Record",
                text: "The selected record is missing an ID.",
            });
            return;
        }

        console.log("✅ Sending Id:", formData.Id); // should not be undefined or empty

        axios
            .get(
                `${API_URL}/get-AwakAdvanceSelectedRecord?Doc_No=${formData.Doc_No}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            )
            .then((response) => {
                const data = response.data;
                // const isLockedNew = data.last_head_data.LockedRecord;
                // const isLockedByUserNew = data.last_head_data.LockedUser;

                // if (isLockedNew) {
                //   Swal.fire({
                //     icon: "warning",
                //     title: "Record Locked",
                //     text: `This record is locked by ${isLockedByUserNew}`,
                //     confirmButtonColor: "#d33",
                //   });
                //   return
                // }
                // else {
                //   lockRecord();
                // }
                setFormData({
                    ...formData,
                    ...data.last_head_data,
                });
                setIsEditMode(true);
                setAddOneButtonEnabled(false);
                setSaveButtonEnabled(true);
                setCancelButtonEnabled(true);
                setEditButtonEnabled(false);
                setDeleteButtonEnabled(false);
                setBackButtonEnabled(true);
                setIsEditing(true);
            })
            .catch((error) => {
                // window.alert("This record is already deleted! Showing the previous record.");
            });
    };

    const handleSaveOrUpdate = async () => {
        
        const Post_Date = sessionStorage.getItem("Post_Date");
        const Outword_Date = sessionStorage.getItem("Outword_Date")
        if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
            return;
        }

        const accountingYearData = sessionStorage.getItem("Accounting_Year");
        const formattedEntryDate = formData.Doc_Date;
        const isValid = validateDocumentDate(
            formattedEntryDate,
            accountingYearData
        );

        if (!isValid) {
            return;
        }

        if (!formData.Advance || Number(formData.Advance) === 0) {
            Swal.fire({
                title: "Invalid Advance Amount",
                text: "Advance amount cannot be 0. Please enter a valid amount.",
                icon: "warning",
                confirmButtonText: "OK"
            });
            setIsLoading(false);
            return;
        }
        if (!formData.Cash_Bank_Ac || Number(formData.Cash_Bank_Ac) === 0) {
            Swal.fire({
                title: "Fill Cash Bank",
                text: "Cash Bank A/C cannot be Empty.",
                icon: "warning",
                confirmButtonText: "OK"
            });
            setIsLoading(false);
            return;
        }
        setIsEditing(true);
        setIsLoading(true);

        if (awakChanged && formData.Ac_Code !== framer) {
            Swal.fire({
                title: "Farmer Mismatch!",
                text: "Selected Farmer does not match the Farmer linked with this Awak No.",
                icon: "error",
                confirmButtonText: "OK"
            });
            setIsLoading(false);
            return;  // ❌ Stop Save/Update
        }
        if (isEditMode) {
            const responseData = {
                ...formData,
                Modified_By: username
            }
            axios
                .put(
                    `${API_URL}/update-AwakAdvance?Doc_No=${formData.Doc_No}&Company_Code=${companyCode}&Year_Code=${Year_Code}`,
                    responseData
                )
                .then((response) => {
                    Swal.fire({
                        title: "Success!",
                        text: "Record updated successfully!",
                        icon: "success",
                        confirmButtonText: "OK"
                    });
                    setIsEditMode(false);
                    setAddOneButtonEnabled(true);
                    setEditButtonEnabled(true);
                    setDeleteButtonEnabled(true);
                    setBackButtonEnabled(true);
                    setSaveButtonEnabled(false);
                    setCancelButtonEnabled(false);
                    setUpdateButtonClicked(true);
                    setIsEditing(false);
                })
                .catch((error) => {
                    handleCancel();
                    console.error("Error updating data:", error);
                })
                .finally(() => {
                    setIsLoading(false); // Stop spinner
                });
        } else {
            const responseData = {
                ...formData,
                Created_By: username
            }
            axios
                .post(
                    `${API_URL}/create-Record-AwakAdvance?Company_Code=${companyCode}&Year_Code=${Year_Code}`,
                    responseData
                )
                .then((response) => {
                    Swal.fire({
                        title: "Success!",
                        text: "Record Created successfully!",
                        icon: "success",
                        confirmButtonText: "OK"
                    });
                    setIsEditMode(false);
                    setAddOneButtonEnabled(true);
                    setEditButtonEnabled(true);
                    setDeleteButtonEnabled(true);
                    setBackButtonEnabled(true);
                    setSaveButtonEnabled(false);
                    setCancelButtonEnabled(false);
                    setUpdateButtonClicked(true);
                    setIsEditing(false);

                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                    navigate(`/Awakadvance-api?navigatedRecord=${formData.Doc_No}`);
                })
                .catch((error) => {
                    console.error("Error saving data:", error);
                })
                .finally(() => {
                    setIsLoading(false); // Stop spinner
                });
        }
    };


    const handleDelete = async () => {

        try {

            const isUsed = await checkAdvanceUsage(formData.Doc_No);

            if (isUsed) {
                Swal.fire({
                    icon: "error",
                    title: "Cannot Delete",
                    text: "This Doc No is already used in Patti. You cannot delete it.",
                    confirmButtonColor: "#d33",
                });
                return;
            }

            // if (
            //   await OutwordPostDateRecordLock(
            //     formData.doc_date,
            //     // Post_Date,
            //     // Outword_Date
            //   )
            // ) {
            //   return;
            // }

            // if (parseInt(formData.doc_no) !== 0) {
            //   Swal.fire({
            //     title: "Error",
            //     text: `Couldn't delete this record it is currently referenced in DO No. ${formData.DO_No}`.trim(),
            //     icon: "error",
            //     confirmButtonText: "OK",
            //   });
            //   return;
            // }

            // if (parseInt(formData.einvoiceno) !== "" && formData.ackno !== "") {
            //   Swal.fire({
            //     icon: "warning",
            //     text: "E-Invoice has already been generated for this record.Cannot Delete.",
            //     confirmButtonColor: "#d33",
            //   });
            //   return;
            // }

            // if (formData.EWay_Bill_No !== "") {
            //   Swal.fire({
            //     icon: "warning",
            //     text: "E-WayBill has already been generated for this record.Cannot Delete.",
            //     confirmButtonColor: "#d33",
            //   });
            //   return;
            // }

            const response = await axios.get(
                `${API_URL}/get-AwakAdvanceSelectedRecord?Doc_No=${formData.Doc_No}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );

            const data = response.data;
            // const isLockedNew = data.last_head_data.LockedRecord;
            // const isLockedByUserNew = data.last_head_data.LockedUser;

            // if (isLockedNew) {
            //   Swal.fire({
            //     title: "Record Locked",
            //     text: `This record is locked by ${isLockedByUserNew}`,
            //     icon: "warning",
            //     confirmButtonText: "OK",
            //   });
            //   return;
            // }

            const result = await Swal.fire({
                title: "Are you sure?",
                text: `Do you really want to delete this Doc No: ${formData.Doc_No}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                cancelButtonText: "Cancel",
                confirmButtonText: "Delete",
                reverseButtons: true,
                focusCancel: true,
            });

            if (result.isConfirmed) {
                setIsEditMode(false);
                setAddOneButtonEnabled(true);
                setEditButtonEnabled(true);
                setDeleteButtonEnabled(true);
                setBackButtonEnabled(true);
                setSaveButtonEnabled(false);
                setCancelButtonEnabled(false);
                setIsLoading(true);

                const deleteApiUrl = `${API_URL}/delete-AwakAdvance?Doc_No=${formData.Doc_No}&Company_Code=${companyCode}&Doc_No=${formData.Doc_No}&Year_Code=${Year_Code}`;
                const response = await axios.delete(deleteApiUrl);

                if (response.status === 200) {
                    Swal.fire({
                        title: "Deleted!",
                        text: "Data deleted successfully!",
                        icon: "success",
                        confirmButtonText: "OK",
                    });
                    const docNoNum = parseInt(formData.Doc_No);
                    if (!docNoNum || docNoNum <= 1) {
                        handleAddOne();
                    } else {

                        handleCancel();
                    }
                } else {
                    Swal.fire({
                        title: "Error",
                        text: "Failed to delete the record.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } else {
                Swal.fire({
                    title: "Cancelled",
                    text: "Your record is safe 🙂",
                    icon: "info",
                    confirmButtonText: "OK",
                });
            }
        } catch (error) {
            console.error("Error during API call:", error);
            Swal.fire({
                title: "Error",
                text: `There was an error during the deletion: ${error.message}`,
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            setIsLoading(false);
        }
    };

    //Common Feilds that we haev to set the record on the navigations.
    const NavigationSetFields = (data, dataKey) => {
        
        partyName = data.labels.Ac_Name_E;
        partyCode = data[dataKey].Ac_Code;
        accoid = data[dataKey].ac;
        brokerName = data.labels.CaskBankAcName;
        brokerCode = data[dataKey].Cash_Bank_Ac;

        return data[dataKey];
    };


    //Navigation Buttons
    const handleFirstButtonClick = async () => {
        try {
            const response = await fetch(`${API_URL}/get-first-AwakAdvance?Company_Code=${companyCode}&Year_Code=${Year_Code}`);
            if (response.ok) {
                const data = await response.json();
                const extractedData = NavigationSetFields(data, 'first_AwakAdvance_data');
                setFormData({ ...formData, ...extractedData });
            } else {
                console.error(
                    "Failed to fetch record:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handlePreviousButtonClick = async () => {
        try {
            const response = await fetch(
                `${API_URL}/get-previous-AwakAdvance?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`
            );
            if (response.ok) {
                const data = await response.json();
                const extractedData = NavigationSetFields(data, 'previous_Awakadvance_data');
                setFormData({
                    ...formData,
                    ...extractedData,
                });
            } else {
                console.error(
                    "Failed to fetch record:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleNextButtonClick = async () => {
        try {
            const response = await fetch(
                `${API_URL}/get-next-AwakAdvance?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${formData.Doc_No}`
            );
            if (response.ok) {
                const data = await response.json();
                const extractedData = NavigationSetFields(data, 'next_AwakAdvance_data');
                setFormData({
                    ...formData,
                    ...extractedData,
                });
            } else {
                console.error(
                    "Failed to fetch  record:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleLastButtonClick = async () => {
        try {
            const response = await fetch(`${API_URL}/get-AwakAdvance-lastRecord?Company_Code=${companyCode}&Year_Code=${Year_Code}`);
            if (response.ok) {
                const data = await response.json();
                const extractedData = NavigationSetFields(data, 'last_AwakAdvance_data');
                setFormData({
                    ...formData,
                    ...extractedData,
                });
            } else {
                console.error(
                    "Failed to fetch record:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleCancel = () => {
        axios
            .get(
                `${API_URL}/get-AwakAdvance-lastRecord?Company_Code=${companyCode}&Year_Code=${Year_Code}`
            )
            .then((response) => {
                const data = response.data;
                const extractedData = NavigationSetFields(data, 'last_AwakAdvance_data');
                setFormData({
                    ...formData,
                    ...extractedData,
                });

            })

            .catch((error) => {
                console.error("Error fetching edit:", error);
            });
        // Reset other state variables
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
    };

    // handle back button to navigate to the dashboard page.
    const handleBack = () => {
        navigate("/Awaka-Advance-utility");
    };

    const checkAdvanceUsage = async (Advance_No) => {
        try {
            const res = await axios.get(`${API_URL}/check-Advance-usage`, {
                params: {
                    Doc_No: Advance_No,
                    Company_Code: companyCode,
                    // Year_Code: Year_Code, // Uncomment if needed
                },
            });

            return res.data?.isUsed ?? false; // Always return a boolean
        } catch (err) {
            console.error("Error checking Proforma usage:", err);
            return false; // Fail-safe
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    useEffect(() => {
        if (selectedRecord) {
            handlerecordDoubleClicked();
        } else if (
            navigatedRecord &&
            !isNaN(navigatedRecord) &&
            parseInt(navigatedRecord) > 0
        ) {
            handleNavigateRecord();
        } else {
            handleAddOne();
        }
    }, [selectedRecord, navigatedRecord]);




    const handlerecordDoubleClicked = async () => {
        
        try {
            const response = await axios.get(
                `${API_URL}/get-AwakAdvanceSelectedRecord?Company_Code=${companyCode}&Year_Code=${Year_Code}&Doc_No=${selectedRecord.Doc_No}`

            );
            console.log("SelectedREcordDocNo", selectedRecord.Doc_No)
            const data = response.data;
            const extractedData = NavigationSetFields(data, 'selected_Record_data');
            setFormData({
                ...formData,
                ...extractedData,
            });
            setIsEditing(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setUpdateButtonClicked(true);
        setIsEditing(false);
    };

    const handleNavigateRecord = async () => {
        setIsEditing(false);
        setIsEditMode(false);
        setAddOneButtonEnabled(true);
        setEditButtonEnabled(true);
        setDeleteButtonEnabled(true);
        setBackButtonEnabled(true);
        setSaveButtonEnabled(false);
        setCancelButtonEnabled(false);
        setCancelButtonClicked(true);
        try {
            const response = await axios.get(
                `${API_URL}/get-AwakAdvanceSelectedRecord?Doc_No=${navigatedRecord}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
            );
            if (response.status === 200) {
                const data = response.data;
                partyName = data.labels.Ac_Name_E;
                partyCode = data.selected_Record_data.Ac_Code;
                brokerName = data.labels.CaskBankAcName;
                brokerCode = data.selected_Record_data.Cash_Bank_Ac;
                setFormData({
                    ...formData,
                    ...data.selected_Record_data,
                });
            } else {
                console.error(
                    "Failed to fetch last tender data:",
                    response.status,
                    response.statusText
                );
            }
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const handleKeyDown = async (event) => {
        if (event.key === "Tab") {
            const changeNoValue = event.target.value;
            try {
                const response = await axios.get(
                    `${API_URL}/get-AwakAdvanceSelectedRecord?Doc_No=${changeNoValue}&Company_Code=${companyCode}&Year_Code=${Year_Code}`
                );
                const data = response.data;
                partyName = data.labels.Ac_Name_E;
                partyCode = data.selected_Record_data.Ac_Code;
                brokerName = data.labels.CaskBankAcName;
                brokerCode = data.selected_Record_data.Cash_Bank_Ac;
                setFormData({
                    ...formData,
                    ...data.selected_Record_data,
                });
                setIsEditing(false);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
    };

    //-------------------------------------------- Detail Section Start ----------------------------------------------------

    const handleframer = async (
        code,
        accoid,
        mobile,

    ) => {
        
        console.log("handleframer", code, accoid,)
        setFramer(code);
        setFramerAccoid(accoid);
        setPartyMobNo(mobile);
        let updatedFormData = {
            ...formData,
            Ac_Code: code,
            ac: accoid,
        };
        setFormData(updatedFormData);


    };

    const handleFetchedAwakData = (data) => {
        const row = data?.all_data?.[0];
        if (row) {
            setFramer(row.Ac_code || "");
            setFramerAccoid(row.ac || "")
            setFormData(prev => ({
                ...prev,
                Awak_No: row.Doc_No,
                Awak_Id: row.Id,
                Ac_Code: row.Ac_code || "",
                Narration: `Qty: ${row.AwakQty}`,
            }));
        }
    };






    const handleborker = async (code, accoid) => {
        console.log("handleborker", code, accoid,)
        setBroker(code);
        let updatedFormData = {
            ...formData,
            Cash_Bank_Ac: code,
            cb: accoid,
        };
        setFormData(updatedFormData);
    };

    const handleAwakcode = (Doc_No, id, Ac_code, ac, FarmerName) => {
        console.log("handleAwakcode", Doc_No, id, Ac_code, ac, FarmerName)
        setAwakChanged(true);
        setAwakId(id);
        setAwakCode(Doc_No);
        setFramer(Ac_code);
        setFramerAccoid(ac);

        let updatedFormData = {
            ...formData,
            Awak_No: Doc_No,
            Awak_Id: id,
        };

        if (!billToManuallySet) {
            setFramer(Ac_code);
            partyName = FarmerName
            partyCode = Ac_code

            updatedFormData.Ac_Code = Ac_code;
            updatedFormData.ac = ac;
        }

        setFormData(updatedFormData);
    }

    const parseBankDetail = (bankDetailStr) => {
        if (!bankDetailStr) return { bank: "", acNo: "", branch: "" };

        // Extract bank name after "BANK -" and before "A/C NO"
        const bankMatch = bankDetailStr.match(/BANK\s*-\s*(.*?)\s*A\/C NO/i);
        const bank = bankMatch ? bankMatch[1].trim() : "";

        // Extract account number after "A/C NO" and before "IFSC"
        const acMatch = bankDetailStr.match(/A\/C NO\s*([\d]+)/i);
        const acNo = acMatch ? acMatch[1].trim() : "";

        // Extract branch after "BRANCH-"
        const branchMatch = bankDetailStr.match(/BRANCH\s*-\s*(.*)/i);
        const branch = branchMatch ? branchMatch[1].trim() : "";

        return { bank, acNo, branch };
    };



    const handleTransferToRTGS = async () => {
        try {
            const res = await axios.get(
                `${API_URL}/TransferDataTo-RTGS`,
                {
                    params: {
                        Company_Code: companyCode,
                        Year_Code: Year_Code,
                        Id: formData.Id
                    }
                }
            );

            const data = res.data.all_data[0];

            const { bank, acNo, branch } = parseBankDetail(data.bankdetail);

            // Map API → RTGS form
            const rtgsFormData = {
                Ac_code: data.Ac_Code,
                Ac: data.ac,
                Party_name: data.FarmerName?.trim(),
                Party_Bank: data.Bank_Name?.trim(),
                Party_Branch: data.Branch?.trim(),
                Party_Ac_No: data.Bank_Ac_No?.trim(),
                Ifsc: data.IFSC,
                Amount: parseFloat(data.Advance),
                Our_Bank: bank?.trim(),
                Our_Branch: branch?.trim(),
                Our_AC_No: acNo?.trim(),
                cheque_No: data.chequeno,
                // Total: parseFloat(data.Advance),
                Company_Code: data.Company_Code,
                Year_Code: data.Year_Code,

            };

            // Navigate with state
            navigate("/rtgs-form", { state: rtgsFormData });

        } catch (error) {
            console.error(error);
            alert("Failed to transfer data to RTGS");
        }
    };





    return (
        <>
            <UserAuditInfo
                createdBy={formData.Created_By}
                modifiedBy={formData.Modified_By}
                title={"Awak Advance"}
            />
            <ToastContainer autoClose={500} />
            <br></br>
            <ActionButtonGroup
                handleAddOne={handleAddOne}
                addOneButtonEnabled={addOneButtonEnabled}
                handleSaveOrUpdate={handleSaveOrUpdate}
                saveButtonEnabled={saveButtonEnabled}
                isEditMode={isEditMode}
                handleEdit={handleEdit}
                editButtonEnabled={editButtonEnabled}
                handleDelete={handleDelete}
                deleteButtonEnabled={deleteButtonEnabled}
                handleCancel={handleCancel}
                cancelButtonEnabled={cancelButtonEnabled}
                handleBack={handleBack}
                backButtonEnabled={backButtonEnabled}
                isDeleted={formData.IsDeleted === 0}
                permissions={permissions}
                component={<div style={{ display: 'flex' }} >
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: "10px" }}
                        onClick={handleTransferToRTGS}
                        disabled={!addOneButtonEnabled}
                    >
                        Transfer To RTGS
                    </Button>
                </div>}
            />
            <NavigationButtons
                handleFirstButtonClick={handleFirstButtonClick}
                handlePreviousButtonClick={handlePreviousButtonClick}
                handleNextButtonClick={handleNextButtonClick}
                handleLastButtonClick={handleLastButtonClick}
                highlightedButton={highlightedButton}
                isEditing={isEditing}
            />


            <div >
                <form onSubmit={handleSubmit}>
                    <Grid container alignItems="center" spacing={1} mt={0.5}>
                        <Grid item xs={12} sm={1}>
                            <FormControl fullWidth>
                                <TextField
                                    label="Change No"
                                    variant="outlined"
                                    name="changeNo"
                                    autoComplete="off"
                                    onKeyDown={handleKeyDown}
                                    disabled={!addOneButtonEnabled}
                                    fullWidth
                                    size="small"
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <FormControl>
                                <TextField
                                    label="Doc No"
                                    variant="outlined"
                                    name="Doc_No"
                                    autoComplete="off"
                                    value={formData.Doc_No}
                                    onChange={handleChange}
                                    disabled
                                    fullWidth
                                    size="small"
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} sm={1}>
                            <FormControl>
                                <TextField
                                    inputRef={inputRef}
                                    type="date"
                                    label="Date"
                                    variant="outlined"
                                    name="Doc_Date"
                                    value={formData.Doc_Date}
                                    onChange={handleChange}
                                    disabled={!isEditing && addOneButtonEnabled}
                                    firstInputRef={firstInputRef}
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{
                                        style: { fontSize: "14px" },
                                    }}
                                    InputProps={{
                                        style: { fontSize: "12px", height: "40px" },
                                    }}
                                />
                            </FormControl>
                        </Grid>


                    </Grid>

                    <div className="otherpurchase-row" style={{ marginLeft: "1px" }}>
                        <label htmlFor="Bill_From" className="SugarSaleBillLabel">
                            Awak No:
                        </label>
                        <div >
                            <div >
                                <AwakEntryhelp
                                    helpMode="ADVANCE"
                                    onAcCodeClick={handleAwakcode}
                                    // Awak_No={formDataDetail.Awak_No}
                                    Doc_No={formData.Awak_No}
                                    DetailId={formData.Awak_Id}
                                    onFetchedData={handleFetchedAwakData}
                                    Ac_type={[]}
                                    name="Awak_No"
                                    tabIndexHelp={0}
                                    firstInputRef={firstInputRef}
                                    farmerCode={Number(framer)}
                                    enableFetchData={true}
                                    enableFarmerFilter={false}
                                    disabledFeild={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="otherpurchase-row" style={{ marginTop: "10px" }}>
                        <label htmlFor="Bill_From" className="SugarSaleBillLabel">
                            Farmer :
                        </label>
                        <div>
                            <div>
                                <AccountMasterHelp
                                    onAcCodeClick={handleframer}
                                    CategoryName={partyName}
                                    CategoryCode={partyCode}
                                    name="Ac_Code"
                                    Ac_type={[]}
                                    disabledFeild={!isEditing && addOneButtonEnabled}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="otherpurchase-row" style={{ marginBottom: "20px" }}>
                        <label htmlFor="Bill_To" className="SugarSaleBillLabel">
                            Cash/Bank Ac:
                        </label>
                        <div>
                            <div>
                                <AccountMasterCashBank
                                    onAcCodeClick={handleborker}
                                    CategoryName={brokerName}
                                    CategoryCode={brokerCode}
                                    name="Cash_Bank_Ac"
                                    Ac_type={[]}
                                    disabledFeild={!isEditing && addOneButtonEnabled}
                                />
                            </div>
                        </div>
                    </div>




                    <Grid container spacing={2}>


                        {/* Advance Type */}
                        <Grid item>
                            <Grid container alignItems="center" spacing={3.4}>
                                <Grid item>
                                    <label htmlFor="Advance_Type" style={{ fontWeight: "bold", minWidth: "100px" }}>
                                        Advance Type:
                                    </label>
                                </Grid>
                                <Grid item>
                                    <FormControl size="small" style={{ minWidth: "150px" }}>
                                        <Select
                                            labelId="advance_type_label"
                                            id="Advance_Type"
                                            name="Advance_Type"
                                            value={formData.Advance_Type}
                                            onChange={handleChange}
                                            disabled={!isEditing && addOneButtonEnabled}
                                        >
                                            <MenuItem value="A">Advance</MenuItem>
                                            <MenuItem value="M">Motor Freight</MenuItem>
                                            <MenuItem value="H">Hamali</MenuItem>
                                            <MenuItem value="T">Transfer</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                        {/* Advance Amount */}
                        <Grid item>
                            <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                    <label htmlFor="Advance" style={{ fontWeight: "bold", minWidth: "120px" }}>
                                        Advance Amount:
                                    </label>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        type="number"
                                        id="Advance"
                                        name="Advance"
                                        autoComplete="off"
                                        value={formData.Advance !== null ? formData.Advance : 0.0}
                                        onChange={handleChange}
                                        disabled={!isEditing && addOneButtonEnabled}
                                        variant="outlined"
                                        size="small"
                                        inputProps={{ step: "0.01" }}
                                        style={{ minWidth: "120px" }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display="flex" alignItems="flex-start" gap={6}>
                                <label
                                    htmlFor="chequeno"
                                    style={{
                                        minWidth: "5px",
                                        fontWeight: "bold",
                                        marginTop: "8px",
                                    }}
                                >
                                    Cheque No:
                                </label>


                                <TextField
                                    id="chequeno"
                                    name="chequeno"
                                    value={formData.chequeno || ""}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    variant="outlined"
                                    disabled={!isEditing && addOneButtonEnabled}
                                    size="small"
                                    style={{ minWidth: "400px" }}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12}>
                            <Box display="flex" alignItems="flex-start" gap={8}>
                                <label
                                    htmlFor="Narration"
                                    style={{
                                        minWidth: "10px",
                                        fontWeight: "bold",
                                        marginTop: "8px",
                                    }}
                                >
                                    Narration:
                                </label>


                                <TextField
                                    id="Narration"
                                    name="Narration"
                                    value={formData.Narration}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    variant="outlined"
                                    disabled={!isEditing && addOneButtonEnabled}
                                    size="small"
                                    multiline
                                    rows={4}
                                    style={{ minWidth: "450px" }}
                                />
                            </Box>
                        </Grid>


                    </Grid>

                    {isLoading && (
                        <div className="loading-overlay">
                            <div className="spinner-container">
                                <SaveUpdateSpinner />
                            </div>
                        </div>
                    )}
                </form>
            </div>
        </>
    );
};

export default AwakAdvance;
